import {
    AIRLINES_FILTER_SHOW_ALL,
    AIRLINES_FILTER_SHOW_MORE, CLEAR_FILTER, PARENT_FILTERS_CHANGED, SELECT_CARRIER_FILTER, SET_SELECTED_URL_FILTERS,
    SOCKET_CARRIER_FILTERS_UPDATED, RESET_ALL_FILTERS
} from "../../actions/FlightsActions";

const initialState = {
    carriers: {},
    selected: [],
    page: 1,
    showAll: false
};

const AirlinesFilterReducer = (state = initialState, action) => {
    switch (action.type) {
        case SOCKET_CARRIER_FILTERS_UPDATED:
            return {
                ...state, carriers: {...state.carriers, ...action.payload}
            };
        case SELECT_CARRIER_FILTER:
            if (state.selected.indexOf(action.carrier) === -1) {
                return {
                    ...state, selected: [...state.selected, action.carrier]
                };
            }

            return {
                ...state, selected: state.selected.filter(item => item !== action.carrier)
            };
        case SET_SELECTED_URL_FILTERS:
            if (action.name === 'carriers') {
                return {
                    ...state, selected: action.payload
                };
            }

            return state;
        case AIRLINES_FILTER_SHOW_MORE:
            return {...state, page: ++state.page};
        case AIRLINES_FILTER_SHOW_ALL:
            return {...state, showAll: true};
        case PARENT_FILTERS_CHANGED:
            return {...state, selected: action.filters.carriers};
        case CLEAR_FILTER:
            if (action.filter === 'carriers') {
                return {...state, selected: initialState.selected};
            }

            return state;
        case RESET_ALL_FILTERS:
            return {...state, selected: initialState.selected};
        default:
            return state
    }
};

export default AirlinesFilterReducer;



// WEBPACK FOOTER //
// ./src/reducers/filters/AirlinesFilterReducer.js